import type {z} from "zod";

import {ListMaterialsQueryParams} from "@project/sdk/engineering/zod";

export const listMaterialsSearchSchema = ListMaterialsQueryParams.extend({
  page: ListMaterialsQueryParams.shape.page.catch(1).default(1),
  perPage: ListMaterialsQueryParams.shape.perPage.catch(20).default(20),
  q: ListMaterialsQueryParams.shape.q.catch(undefined),
  state: ListMaterialsQueryParams.shape.state.catch("ACTIVE"),
  compositionKind: ListMaterialsQueryParams.shape.compositionKind.catch(undefined),
  supplyStatus: ListMaterialsQueryParams.shape.supplyStatus.catch(undefined),
  functionId: ListMaterialsQueryParams.shape.functionId.catch(undefined),
  unitOfMeasure: ListMaterialsQueryParams.shape.unitOfMeasure.catch(undefined),
  sortKey: ListMaterialsQueryParams.shape.sortKey.catch("materialId"),
  sortDir: ListMaterialsQueryParams.shape.sortDir.catch("asc").default("asc"),
});

export type ListMaterialsSearchInput = z.input<typeof listMaterialsSearchSchema>;
export type ListMaterialsSearch = z.output<typeof listMaterialsSearchSchema>;
